import PATH from '../paths';

const name = 'Associated Broker';
const key = 'associatedbroker';
const imgUrl = `${ PATH.CDN }/whitelabels/associatebroker`;
const images = {
  favicon: `${ imgUrl }/favicon.png`,
  logo: `${ imgUrl }/logo.png`,
  logoSidebar: `${ imgUrl }/logo-sidebar.png`,
  logoPDF: `${ imgUrl }/logo-pdf.png`,
  opengraph: false,
  backgrounds: [
    `${ imgUrl }/background.jpeg`
  ],
};

export default {
  name,
  key,
  images,
  stylesheet: `
    /* COLOR VARIABLES +++++++++++++++++++++++++++++++++++++++++++++++++++++  */


    --color-ab-black:                 #25272e;
    --color-ab-orange:                #fb5627;

    --color-primary:                  var(--color-ab-black);
    --color-secondary:                var(--color-darker);
    --color-accent:                   var(--color-ab-orange);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* TYPOGRAPHY ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
   
    /* LAYOUTS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* ANONYMOUS LAYOUT */

    --anonymous-logo-bg:              var(--color-white);
    --anonymous-copy-bg:              var(--color-primary);
    --anonymous-heading-color:        var(--color-white);
    --anonymous-subheading-color:     var(--color-white);
    --anonymous-text-color            var(--color-white);
    --anonymous-logo-height:          100px;
    --anonymous-bg:                   url(${ images.backgrounds[0] });
    --anonymous-bg-size:              cover;
    --color-link:                     var(--color-ab-orange);
    

    /* END */

    /* SIDEBAR */

    --sidebar-bg-color: var(--color-ab-orange);
    --sidebar-logo-bg-color: var(--color-white);
    --sidebar-label-color: var(--color-white);
    --sidebar-border-color: var(--color-ab-orange);

    --sidebar-button-color: var(--color-white);
    --sidebar-button-color-active: var(--color-white);
    --sidebar-button-color-hover: var(--color-white);
    --sidebar-button-bg-color: transparent;
    --sidebar-button-bg-color-active: var(--color-ab-black);
    --sidebar-button-bg-color-hover: var(--color-ab-black);
    --sidebar-button-border-color: var(--color-white);
    --sidebar-button-border-color-active: var(--color-ab-black);
    --sidebar-button-border-color-hover: var(--color-ab-black);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* BUTTONS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* PRIMARY BUTTON */

    --btn-primary--bg:                var(--color-accent);
    --btn-primary--border:            var(--color-accent);
    --btn-primary--color:             var(--color-white);
    --btn-primary--colorH:            var(--color-white);
    --btn-primary--bgH:               var(--color-ab-black);
    --btn-primary--borderH:           var(--color-ab-black);

    /* END */

    /* SECONDARY BUTTON */

    --btn-secondary--bg:              transparent;
    --btn-secondary--border:          var(--color-accent);
    --btn-secondary--color:           var(--color-accent);
    --btn-secondary--bgH:             transparent;
    --btn-secondary--borderH:         var(--color-accent);
    --btn-secondary--colorH:          var(--color-accent);

    /* END */


    /* FILTER BUTTONS */

    .p-button--switchboard--active {
      --button-text-color:                var(--color-white);
      --button-text-color-hover:          var(--color-white)!important;
      --switchboard-nav-figure-bg-color:  var(--color-white);
    }

    .c-switchboard__heading figure .m-icon {
      --switchboard-nav-figure-bg-color:  --button-text-color;
    }

    /* END */


    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
  `,
};
